import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';
import { Neutrals } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  modal: {
    minHeight: 250,
    borderRadius: CornerRadius.Huge,
    padding: 0,
  },
  container: {
    alignItems: 'center',
    height: '100%',
    padding: Spacing.Cozy,
  },
  containerWithCloseIcon: {
    paddingTop: Spacing.Ample,
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 8,
  },
  contentContainer: {
    flexGrow: 1,
    gap: Spacing.Compact,
    justifyContent: 'center',
    width: "100%"
  },
  contentContainerWithMarginTop: {
    marginTop: Spacing.Compact,
  },
  contentContainerWithMarginBottom: {
    marginBottom: Spacing.Cozy,
  },
  title: {
    ...textLatoStyleDS.TitleBoldXl,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
  description: {
    ...textLatoStyleDS.BodyRegularMd,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
  ctaContainer: {
    flexDirection: 'row',
    gap: Spacing.Condensed,
    width: '100%',
  },
  ctaButton: {
    flex: 1,
  },
  closeIcon: {
    color: Buttons.ghostBlack.ButtonGhostBlackIconDefault,
  },
});

export const mobileStyle = StyleSheet.create({
  title: {
    textAlign: 'center',
    ...textLatoStyleDS.TitleBoldLg,
  },
  description: {
    ...textLatoStyleDS.BodyRegularSm,
  },
  modal: {
    width: '90%',
  },
  ctaContainer: {
    flexDirection: 'column-reverse',
    gap: Spacing.Condensed,
    width: '100%',
  },
});
